/* istanbul ignore file */
import { Text } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import ContactInfoHeaderImage from '../../../../assets/contact_info_header_image.png'
import styles from './styles.scss'

const cx = classnames.bind(styles)
export const PasswordlessSignupHeader: React.FC = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <img
        src={ContactInfoHeaderImage}
        alt='Contact Info Header'
        className={cx('contact-info-image')}
      />
      <p className={cx('contact-info-header')}>Let’s get you started.</p>
    </div>
  )
}

export const PasswordlessSignupSubHeader: React.FC = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Text size='big' weight='heavy'>
        We’ll use your email to save your progress and create your listing.
      </Text>
    </div>
  )
}

export const WelcomeBackHeader: React.FC = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <img
        src={ContactInfoHeaderImage}
        alt='Welcome Back Header'
        className={cx('contact-info-image')}
      />
      <p className={cx('contact-info-header')}>Welcome Back!</p>
    </div>
  )
}

export const WelcomeBackSubHeader: React.FC = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <Text size='big' weight='heavy'>
        We’ll use your email to save your progress and create your listing.
      </Text>
    </div>
  )
}

export default PasswordlessSignupHeader
